import { ItemCardLocalCombination } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardLocalCombination/ItemCardLocalCombination";
import { ItemCardDefault } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardDefault/ItemCardDefault";
import React from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";

interface SearchResultsListViewItemChildrenProps {
  item: Item;
  isLocalCombination: boolean;
}

export const SearchResultsListViewItemChildren = ({
  item,
  isLocalCombination,
}: SearchResultsListViewItemChildrenProps) => {
  return (
    <>
      {isLocalCombination && <ItemCardLocalCombination item={item} />}
      {!isLocalCombination && <ItemCardDefault item={item as Item} />}
    </>
  );
};
